import { HOME_FEED_TAB_KEYS } from '~/utils/home-feed-tab-keys';

export const homeForYouFeedCursor = (state) => state.homeForYouFeedCursor;
export const homeForYouFeed = (state) => state.homeForYouFeed;
export const newPostNumber = (state) => state.newPostNumber;
export const homeForYouFeedLoading = (state) => state.homeForYouFeedLoading;
export const nextHomeForYouPostsLoading = (state) =>
  state.nextHomeForYouPostsLoading;
export const error = (state) => state.error;
export const deleteUserPost = (state) => state.deleteUserPost;
export const homeNewsFeed = (state) => state.homeNewsFeed;
export const homeNewsFeedLoading = (state) => state.homeNewsFeedLoading;
export const nextHomeNewsPostsLoading = (state) =>
  state.nextHomeNewsPostsLoading;
export const homeNewsFeedCursor = (state) => state.homeNewsFeedCursor;
export const feedTabs = (state) => state.feedTabs;
export const activeFeedTab = (state) => state.activeFeedTab;
export const homeForYouFeedTabActive = (state) =>
  state.activeFeedTab.key === HOME_FEED_TAB_KEYS.FOR_YOU;
export const homeNewsFeedTabActive = (state) =>
  state.activeFeedTab.key === HOME_FEED_TAB_KEYS.NEWS;
